<template>
    <div  id="block-distribution-settings" class="body" ref="body">
        <v-skeleton-loader boilerplate class="m-3"
                           v-if="loading"
                           type="chip"
        ></v-skeleton-loader>
        <div v-else class="content">
            <div class="distribution-settings">
                <!-- Distribution settings -->
                <label>{{distributionTitle || $t("message.new_members_distribution_rule")}}</label>
                <b-dropdown v-bind="$props"

                            id="b_drp_dist"
                            :text="(sponsorTeam === 0 || sponsorTeam == null) ? $t('message.auto') : sponsorTeam === 1 ? $t('message.left_team') : $t('message.right_team')">
                    <b-dropdown-item v-for="(item,index) in teamFloats" v-bind:key="item.id"
                                     @click="loadLeg(index)">
                        {{index === 0 ? $t('message.auto') : index === 1 ? $t('message.left_team') :
                        $t('message.right_team')}}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
    import {VSkeletonLoader} from 'vuetify/lib'
    import {BDropdownItem} from 'bootstrap-vue'
    import BDropdown from '../../nested_components/bootstrap-vue/BDropdown'
    import Layer0 from '../../extend_classes/Layer0';
    //const sponsorTeamAlias= 'SponsorTeam'; // PV works
    const i18n = new window.VueI18n({
        locale: 'en-US',
        fallbackLocale: 'en-US',
        messages: {
            "en-US": {
                "message": {
                    "new_members_distribution_rule": "New members distribution rule",
                    "left_team": "Left team",
                    "right_team": "Right team",
                    "auto": "Auto"
                }
            }
        }
    });
    export default {
        name: "distribution-settings",
        i18n: i18n,
        extends: Layer0,
        components: {
            BDropdown,
            BDropdownItem,
            VSkeletonLoader
        },
        data: function () {
            return {
                spillId_d: null,
                teamFloats: ['Auto', 'Left', 'Right'],
                sponsorTeam: 0,
                loc_name: 'VDistributionSettings'
            }
        },
        props: {
            spillId: {
                required: false
            },
            value: {
                required: false
            },
            disabled: {
                required: false,
                type: Boolean
            },
            dropleft: {
                required: false,
                type: Boolean
            },
            marketingProperty: {
                default: 'm.SponsorTeam',
                required: false,
                type: String
            },
            dropright: {
                required: false,
                type: Boolean
            },
            dropup: {
                required: false,
                type: Boolean
            },
            directEdit: {
                required: false,
                type: Boolean
            },
            lazy: {
                required: false,
                type: Boolean
            },
            right: {
                required: false,
                type: Boolean
            },
            variant: {
                required: false,
                type: String
            },
            treeLeg: {
                required: false,
                type: String
            },
            distributionTitle: {
                required: false,
                type: String
            },
            accountId: {
                required: false,
                type: Number
            },
            ...Layer0.props
        },
        methods: {
            loadLeg(legNum) {
                const legTxt = i => (i === 0 || i === null) ? 'Auto' : i === 1 ? 'Left' : 'Right';
                let acceptHttp = () => {
                    this.store.dispatch('showToast', {
                        title: 'SpillLeg updated',
                        body: 'Value changed from ' + legTxt(this.sponsorTeam) + ' to ' + legTxt(legNum),
                        type: 'success'
                    });
                    this.sponsorTeam = legNum;

                    console.log('legNum__', legNum)
                    this.$emit('input', legNum);
                    this.storeState.state.accountInfo.get(this.aid + '.' + this.marketingProperty).obj_val.value = legNum;
                    this.loading = false;
                };
                let errHttp = () => {
                    this.store.dispatch('showToast', {
                        title: 'SpillLeg error',
                        body: 'Can\'t change from ' + legTxt(this.sponsorTeam) + ' to ' + legTxt(legNum),
                        type: 'error'
                    });
                    this.loading = false;
                };
                this.loading = true;

                this.store.dispatch('requestApi3', {
                    path   : `account/${this.aid}/position`,
                    method : 'get'
                }).then(response => {
                    if (!response.data.success) {
                        console.log('error resp', response)
                        return true
                    }

                    const account = response.data.payload[0]

                    let directEdit = ''
                    if (this.directEdit) {
                        directEdit = '&directEdit=' + this.directEdit
                    }

                    console.log('this.treeLeg ', this.treeLeg )

                    this.store.dispatch('requestApi3', {
                        path: `account/${this.aid}/tree/${this.treeLeg || account.treeId}/property/${this.spillId_d}?offset=${account.offset}${directEdit}`,
                        method: 'put',
                        params_: {
                            "value": legNum
                        }
                    }).then(() => {
                        acceptHttp();
                    }).catch((e) => {
                        console.log('e', e)
                    });
                }).catch((e) => {
                    console.log('e', e)
                    errHttp();
                })
                this.loading = false;
            },
            async getInfo() {
                this.spillId_d = this.spillId||null;
                this.aid = this.accountId || await this.store.dispatch('getAccountId');
                console.log('this.spillId!', this.spillId)
                console.log('dathis.valuevalueta', this.value)
                console.log('isNaN(this.value)', isNaN(this.value))

                if (this.spillId!=null && this.value!=null && !isNaN(this.value)) {
                    this.sponsorTeam = this.value;
                    console.log('--------------9999999-----------------')
                    this.loading     = false;
                    return 1;
                }

                this.store.dispatch('requestApi3', {
                    path: `account/${this.aid}/position?properties[]=${this.marketingProperty.replace(/^.\./g,'')}`,
                    method: 'get'
                }).then(response => {
                    const property = response.data.payload[0].properties.find(item => item.alias === this.marketingProperty.replace(/^.\./g,''));

                    if (property) {
                        this.spillId_d   = property.id;
                        console.log('data_____----__',  property?.value?.raw != null && property?.value?.raw != undefined ? Number(property.value.raw) : 0)
                        console.log('property?.value?.raw ', property?.value?.raw )
                        this.sponsorTeam = property?.value?.raw != null && property?.value?.raw != undefined ? Number(property.value.raw) : 0
                        setTimeout(() => {
                            console.log('sponsorTeamsponsorTeamsponsorTeam', this.sponsorTeam)
                        }, 3000)

                    } else {
                        this.spillId_d   = 261;
                        this.sponsorTeam = 0
                    }

                    this.loading = false;   
                });
            }
        }
    }
</script>

<style scoped>
    @import '~vuetify/dist/vuetify.min.css';
    @import './../../styles/projectStyles/vuetify/vuetify-del.css';
    @import '~bootstrap/dist/css/bootstrap.min.css';
    @import '~bootstrap/dist/css/bootstrap-grid.min.css';
    @import '~bootstrap-vue/dist/bootstrap-vue.min.css';
    @import "./../../styles/monarch/elements/forms.css";
    @import "./../../styles/monarch/themes/components/default.css";
    @import "./../../styles/monarch/elements/buttons.css";
    @import "./../../styles/monarch/helpers/colors.css";
    @import "./assets/distibution-settings.css";
</style>
